import { useAuth0 } from '@auth0/auth0-react';

import { useUserContext } from '@/contexts/user_context';

/**
 * Pure predicate — testable without React context.
 * Returns true when the user qualifies as an internal user
 * (Caesar privilege or @julius.ai email).
 */
export function isInternalUser({
  isCaesar,
  email
}: {
  isCaesar: boolean;
  email?: string | null;
}): boolean {
  return isCaesar || Boolean(email?.endsWith('@julius.ai'));
}

export function useIsInternalUser(): boolean {
  const { isCaesar } = useUserContext();
  const { user } = useAuth0();
  return isInternalUser({ isCaesar, email: user?.email });
}

